
namespace Matrix {

    export function popupMenuShow(menu, e?: Event) {
        if (!menu.parent().length)
            menu.hide().appendTo(document.body).addClass('s-PopupMenu').menu();

        e.preventDefault();
        e.stopPropagation();
        menu.show();
        
        if (e.target) {
            menu.position({
                my: (e.target as HTMLElement).getAttribute("data-my") ?? 'left top',
                at: (e.target as HTMLElement).getAttribute("data-at") ?? 'left bottom',
                of: e.target
            });
        }

        var uq = "popupMenuButton" + new Date().getTime().toString();
        $(document).one('click.' + uq, function () {
            menu.hide();
        });
    }
}